import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Card,
  Group,
  Switch,
  Flex,
  Text,
  Loader,
  Center,
} from "@mantine/core";
import { Link, useParams, Route, Routes } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";

import CandidateSurvey from "@legacy/CandidateSurvey";

import logo from "@assets/images/logo.png";

export default function RemoteCodeDetail() {
  const { t } = useTranslation();
  const params = useParams();
  const { id: codeId } = params;

  const {
    data: code,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["remote-code", codeId],
    queryFn: () => axios.get(`/remote-codes/${codeId}/`),
    retry: false,
  });

  if (true) {
    return <CandidateSurvey />;
  }

  if (isLoading) {
    return (
      <Box pl="md" pr="md">
        <Center h="100vh">
          <Loader />
        </Center>
      </Box>
    );
  }

  if (error) {
    return (
      <Box pl="md" pr="md">
        <Flex justify="center" align="center" h="100vh">
          <div>
            <Flex justify="center" align="center">
              <img
                style={{ width: "250px", margin: "0 auto 2em auto" }}
                src={logo}
                alt="logo"
              />
            </Flex>
            <Text align="center">{error}</Text>
          </div>
        </Flex>
      </Box>
    );
  }

  return <div>{JSON.stringify(code)}</div>;
}
